import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar";
import Banner from "../Section/Banner/Banner";
import About from "../Section/AP/AP";
import Promo from "../Section/Promo/promo";
import Produk from "../Section/Produk/Produk";
import Fasilitas from "../Section/surrounding/Surrounding";
import Lokasi from "../Section/Lokasi/lokasi";
import Footer from "../Section/Footer/Footer";
import Scrolltohashelement from "../Pages/ScrollToHashElement";

const home = () => {
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <Promo />
      <Produk />
      <Fasilitas />
      <Lokasi />
      <Footer />
    </div>
  );
};

export default home;
